// Executive Summary — display rules from the FSD's Business Rules (§6, §8).

// "A count of zero is shown as a dash ('–'), not '00'." An en dash, as the
// slides render it.
export const COUNT_DASH = '–';

/**
 * Batch counts are shown zero-padded to two digits ("02", "01"); a zero count
 * renders as a dash.
 *
 * The FSD scopes the dash to "both Completed Batches and Ongoing Batches",
 * which reads as an exhaustive list only because Planned is never zero in the
 * data it describes. It can be zero here — a campaign whose batches have not
 * reached the extract yet — and a row of "00 – – –" reads as a failed load
 * rather than as "nothing scheduled". Applying the same rule to Planned keeps
 * the row honest.
 */
export const formatCount = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n === 0) return COUNT_DASH;
  return String(n).padStart(2, '0');
};

/**
 * Completion % = ROUND(Completed ÷ Planned × 100), already rounded upstream.
 * Null means the stage has no batches at all, so the ratio is undefined — a
 * dash rather than a fabricated 0%.
 */
export const formatPercent = (value) => {
  const n = Number(value);
  if (value == null || !Number.isFinite(n)) return COUNT_DASH;
  return `${n}%`;
};
